// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Error404_wrapper__Vm2Dx","card":"Error404_card__2STG8","legend":"Error404_legend__1CbX4","caption":"Error404_caption__3q5yV"};